/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { IComponentProps } from '@msdyn365-commerce/core';
import React from 'react';
import { FaExternalLinkAlt } from 'react-icons/fa';
import { IMoeKwrSearchResultContainerResources } from '../moe-kwr-search-result-container.props.autogenerated';
// import React, { useRef, useState } from 'react';

export interface ICollectionItemComponentProps extends IComponentProps<{}> {
    className?: string;
    externalSiteData: any;
    showMoreExternalResources: any;
    externalSiteDataAttributes: any;
    resources?: IMoeKwrSearchResultContainerResources;
    preferredLanguageForError: string;
}

export const ExternalResourcesListView: React.FC<ICollectionItemComponentProps> = (props: any) => {
    const { externalSiteData, className, showMoreExternalResources, resources } = props;
    console.log('external resources', externalSiteData);

    // variable declaration

    return (
        <>
            {externalSiteData.length > 0 ? (
                <div className={className}>
                    {externalSiteData?.map((resource: any, index: number) => (
                        <ExternalResource id={resource.id} resource={resource} key={resource.id} />
                    ))}
                    <div className='moe-search-ext-resources-showmore--btn'>
                        <button onClick={showMoreExternalResources} className='moe-btn moe-btn--primary-blue'>
                            Show More
                            {/* <span className='moe-search-ext-resources-showmore--spinner'></span> */}
                        </button>
                    </div>
                </div>
            ) : (
                <div className='msc-alert msc-alert-warning'>{resources.resultSearchNotFoundTextInMaori}.</div>
            )}
        </>
    );
};

const ExternalResource = (props: any) => {
    const { resource } = props;

    return (
        <div className='moe-search-ext-resource'>
            <div className='moe-search-ext-resource__header'>
                <a href={resource.source_url} aria-label={resource.title} rel='noreferrer' target='_blank'>
                    <h2 className='moe-search-ext-resource--title'>{resource.title}</h2>
                </a>
                <div className='moe-search-ext-resource--source'>
                    <ul>
                        {resource?.dc_type && <li>{resource?.dc_type[0]}</li>}
                        {resource?.content_partner && <li>{resource?.content_partner[0]}</li>}
                        {resource?.collection_title && <li>{resource?.collection_title[0]}</li>}
                    </ul>
                </div>
                <div className='moe-search-ext-resource--description'>
                    <p>
                        {resource.description && `${resource?.description.slice(0, 288)}${resource.description.length > 288 ? '...' : ''}`}
                    </p>
                </div>
            </div>
            <div className='moe-search-ext-resource__footer'>
                <div className='moe-search-ext-resource--image'>
                    {resource.large_thumbnail_url ? (
                        <a href={resource.source_url} aria-label={resource.title} rel='noreferrer' target='_blank'>
                            <img src={resource.large_thumbnail_url} alt='' />
                        </a>
                    ) : (
                        <div className='moe-search-ext-resource__no-image'>No Image</div>
                    )}
                </div>
                <div className='moe-search-ext-resource-link'>
                    <a href={resource.source_url} aria-label={resource.title} rel='noreferrer' target='_blank'>
                        <span>
                            digitalnz.org <FaExternalLinkAlt />
                        </span>
                    </a>
                </div>
            </div>
        </div>
    );
};
